export const getLocalStorageLang = () => localStorage.getItem('lang')
